<template>
  <div id="three-d-character">
    <canvas id="c"></canvas>
    <div id="loading">
      <div>
        <div>...loading...</div>
        <div class="progress">
          <div id="progressbar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main.js"
import { OrbitControls } from "@/assets/js/custom-orbit-controls/ThreeOrbitControlsGizmo__OrbitControls.js"
import { OrbitControlsGizmo } from "@/assets/js/custom-orbit-controls/ThreeOrbitControlsGizmo__OrbitControlsGizmo.js"
import { FlyControls } from "three/examples/jsm/controls/FlyControls.js"

import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js"
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js"
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass.js"

import { GUI } from "@/assets/js/three-js-gui-helper.js"

import { SkeletonUtils } from "three/examples/jsm/utils/SkeletonUtils.js"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader"
import * as THREE from "three/build/three.module.js"

import THREEx from "@/assets/js/threex"

export default {
  name: "lord-shiva",
  watch: {
    lang(nv, ov) {
      // if (nv == "pt") {
      //   this.distanceSpanEl.innerText = "Distância"
      // } else {
      //   this.distanceSpanEl.innerText = "Distance"
      // }
    },
  },
  destroyed() {
    this.renderer.setAnimationLoop(null)
    cancelAnimationFrame(this.frameid)

    this.renderer.domElement.parentElement.removeChild(this.renderer.domElement)
    window.onkeydown = null
    document
      .querySelectorAll(".orbit-controls-gizmo")
      .forEach((el) => el.remove())

    document.querySelectorAll("body > div.dg.ac").forEach((el) => el.remove())
  },
  mounted() {
    this.$route.params.lang && this.language != this.$route.params.lang
      ? (this.language = this.$route.params.lang)
      : null
    eventBus.$on("updateLanguage", this.setLang)

    const canvas = document.querySelector("#c")

    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true })
    renderer.toneMapping = THREE.ReinhardToneMapping
    this.renderer = renderer
    const fov = 21
    const aspect = 100 // the canvas default
    const near = 1
    const far = 2800
    const camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
    camera.position.set(0, 2, 35)
    window.camera = camera
    this.camera = camera

    // const controls = new OrbitControls(camera, canvas)
    function updateCamera() {
      camera.updateProjectionMatrix()
    }

    this.gui = new GUI()
    this.gui
      .add(camera, "fov", 1, 80, { language: this.language })
      .onChange(updateCamera)

    this.isLocalhost ? this.addGuiControls() : null

    const controls = new OrbitControls(camera, renderer.domElement)
    const controlsGizmo = new OrbitControlsGizmo(controls, {
      size: 100,
      padding: 8,
    })

    this.controls = controls
    this.controlsGizmo = controlsGizmo
    controls.ed.target.set(0, 1, 2)
    window.controls = controls
    controls.ed.update()

    const scene = new THREE.Scene()
    scene.background = new THREE.Color("lightgray")

    window.scene = scene

    const flyControls = new FlyControls(camera, renderer.domElement)

    flyControls.movementSpeed = 1000
    flyControls.domElement = renderer.domElement
    flyControls.rollSpeed = Math.PI / 24
    flyControls.autoForward = false
    flyControls.dragToLook = false

    window.flyControls = flyControls

    function addLight(...pos) {
      const color = 0xffffff
      const intensity = 1
      const light = new THREE.DirectionalLight(color, intensity)
      light.position.set(...pos)
      scene.add(light)
      scene.add(light.target)
    }
    addLight(5, 15, 2)
    addLight(-5, 15, 5)
    const light = new THREE.AmbientLight(0x404040) // soft white light
    // const light = new THREE.AmbientLight(0xffffff) // soft white light
    scene.add(light)
    // scene.add( new THREE.AmbientLight( 0x000000 ) );
    const pointLight = new THREE.PointLight(0xffffff, 1)
    scene.add(pointLight)

    const manager = new THREE.LoadingManager()
    manager.onLoad = init

    const progressbarElem = document.querySelector("#progressbar")
    manager.onProgress = (url, itemsLoaded, itemsTotal) => {
      progressbarElem.style.width = `${((itemsLoaded / itemsTotal) * 100) | 0}%`
    }

    const useTwoDots = window.location.href.indexOf("models") > -1
    const models = {
      // cubeHeadKrishna: { url: `../models/krishna-cube-head3.glb` },
      shivaMurti: { url: "../models/shiva-murti-no-candra-v2.glb" },
      candra: { url: "../models/metallic-candra-unlinked-v1.glb" },
    }

    this.model = models

    {
      const glbLoader = new GLTFLoader(manager)
      const fbxLoader = new FBXLoader(manager)

      for (const model of Object.values(models)) {
        if (model.url.indexOf("glb") > -1) {
          glbLoader.load(
            model.url,
            (glb) => {
              model.glb = glb

              if (model.url.indexOf("murti") > -1) {
                model.glb.name = "drumShiva"
              } else if (model.url.indexOf("shiva") > -1) {
                model.glb.name = "shiva"
              } else if (model.url.indexOf("candra") > -1) {
                model.glb.name = "candra"

                glb.scene.children[0].material.emissive.setColorName("red")
                glb.scene.traverse(function (child) {
                  if (child.isMesh && child.name === "Candra") {
                    child.geometry.center() // center here
                    window.candra = child
                  }
                })

                window.glb = glb
              }
            },
            undefined,
            function (error) {
              console.error(error)
            }
          )
        }
      }
    }
    function prepModelsAndAnimations() {
      Object.values(models).forEach((model) => {
        if (model.glb && model.glb.animations) {
          const animsByName = {}
          model.glb.animations.forEach((clip) => {
            animsByName[clip.name] = clip
          })
          model.animations = animsByName
        }
      })
    }

    const mixerInfos = []

    let root,
      localScope = this,
      composer

    function init() {
      // TBD
      // hide the loading bar
      const loadingElem = document.querySelector("#loading")
      loadingElem.style.display = "none"

      prepModelsAndAnimations()

      Object.values(models).forEach((model, index) => {
        let clonedScene
        if (model.glb && model.glb.scene) {
          clonedScene = SkeletonUtils.clone(model.glb.scene)
          root = new THREE.Object3D()
          root.add(clonedScene)
          root.customType = "animated-character"
          root.name = model.glb.name
          // root.name != "candra"  ?  scene.add(root)  :  null
          scene.add(root)

          if (root.name == "drumShiva") {
            window.drumShiva = root
            window.drumShiva.rightOmkaraHandMesh =
              window.drumShiva.children[0].children[2]
            localScope.createOmkaraHandTexture()
          }

          if (index == 0) {
            root.position.x = 0
            root.position.y = -3
          } else if (root.name == "candra") {
            window.candraScene = scene.children.filter(
              (el) => el.name == "candra"
            )[0]
            if (window.candraScene) {
              window.candraScene.position.set(0, 4.1, -0.45)
              window.candra = clonedScene
            }

            const smallSphereGeom = new THREE.SphereGeometry(0.45, 32, 16),
              bigSphereGeom = new THREE.SphereGeometry(4, 32, 16)

            const moonTexture = THREE.ImageUtils.loadTexture(
              "../img/three/moon.jpg"
            )
            const moonMaterial = new THREE.MeshBasicMaterial({
              map: moonTexture,
            })
            const moon = new THREE.Mesh(bigSphereGeom, moonMaterial)
            const pos = { x: 15, y: 0, z: -50 }
            moon.position.set(pos.x, pos.y, pos.z)
            scene.add(moon)
            // window.moon = moon

            const glowEffect = localScope.createGlowEffect()
            const glow = new THREE.Mesh(
              smallSphereGeom.clone(),
              glowEffect.clone()
            )

            glow.name = "glow"
            window.glow = glow

            glow.position.set(-0.15, 4.8, -0.53)
            glow.scale.multiplyScalar(1.5)

            scene.add(glow)

            const glowClone = glowEffect.clone()
            glowClone.uniforms.glowColor.value.setColorName("red")
            const bigGlow = new THREE.Mesh(bigSphereGeom.clone(), glowClone)

            bigGlow.position.set(pos.x, pos.y, pos.z)
            bigGlow.scale.multiplyScalar(1.4)

            scene.add(bigGlow)

            window.backgroundMoon = { moon, bigGlow }
            localScope.initBigMoonEffects(moon, bigGlow)

            this.isLocalhost ? localScope.addMaterialControls() : null

            let counter = 1
            // setInterval(() => {
            //   if (counter == 1) {
            //     clonedScene.children[0].material.emissive.setColorName('red')
            //   } else if (counter == 2) {
            //     clonedScene.children[0].material.emissive.setColorName('blue')
            //   } else if (counter == 3) {
            //     clonedScene.children[0].material.emissive.setColorName('yellow')
            //   }

            //   counter++
            //   if (counter == 4) counter = 1
            // }, 5000);
          }

          const mixer = new THREE.AnimationMixer(clonedScene)

          const actions = Object.values(model.animations).map((clip) => {
            mixer.name = clip.name
            return mixer.clipAction(clip)
          })
          const mixerInfo = {
            mixer,
            actions,
            actionNdx: -1,
            actionsOf: model.glb.name,
          }
          mixerInfos.push(mixerInfo)
          playNextAction(mixerInfo)
        }
      })

      {
        const planeSize = 90

        // const loader = new THREE.TextureLoader()
        // const texture = loader.load("../img/three/checker.png")
        // texture.wrapS = THREE.RepeatWrapping
        // texture.wrapT = THREE.RepeatWrapping
        // texture.magFilter = THREE.NearestFilter
        // const repeats = planeSize / 3
        // texture.repeat.set(repeats, repeats)

        // const planeGeo = new THREE.PlaneGeometry(planeSize, planeSize)
        // const planeMat = new THREE.MeshPhongMaterial({
        //   map: texture,
        //   side: THREE.DoubleSide,
        // })
        // const mesh = new THREE.Mesh(planeGeo, planeMat)
        // mesh.rotation.x = Math.PI * -0.5
        // scene.add(mesh)
      }
      if (!localScope.isMobile()) {
        // document.body.appendChild(controlsGizmo.domElement)
      }
      localScope.distanceSpanEl = document.getElementById("distance-span-el")

      // const renderScene = new RenderPass(scene, camera)

      // const bloomPass = new UnrealBloomPass(
      //   new THREE.Vector2(window.innerWidth, window.innerHeight),
      //   1.5,
      //   0.4,
      //   0.85
      // )
      // bloomPass.threshold = localScope.params.bloomThreshold
      // bloomPass.strength = localScope.params.bloomStrength
      // bloomPass.radius = localScope.params.bloomRadius
      // localScope.bloomPass = bloomPass

      // composer = new EffectComposer(renderer)
      // composer.addPass(renderScene)
      // composer.addPass(bloomPass)
      //
      localScope.domEvents = new THREEx.DomEvents(
        camera,
        renderer.domElement,
        THREE
      )
      localScope.initUserEvents()
      localScope.initOmAudio()
    }

    function playNextAction(mixerInfo, actionIndex, modifier) {
      const { actions, actionNdx } = mixerInfo
      if (modifier) {
        actions.forEach((action, ndx) => {
          action.enabled = false
        })
        actions[actionIndex].enabled = true
        actions[actionIndex].play()
      } else {
        const nextActionNdx = (actionNdx + 1) % actions.length
        mixerInfo.actionNdx = nextActionNdx
        actions.forEach((action, ndx) => {
          if (mixerInfo.actionsOf.toLowerCase().indexOf("shiva") > -1) {
            action.enabled = true
            action.play()
          } else {
            const enabled = ndx === nextActionNdx
            action.enabled = enabled
            if (enabled) {
              action.play()
            }
          }
        })
      }
    }

    function resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement
      const width = canvas.clientWidth
      const height = canvas.clientHeight
      const needResize = canvas.width !== width || canvas.height !== height
      if (needResize) {
        renderer.setSize(width, height, false)
      }
      return needResize
    }

    let then = 0
    let deltaTime = 0
    const render = (now) => {
      now *= 0.001 // convert to seconds
      deltaTime = now - then
      then = now

      if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement
        camera.aspect = canvas.clientWidth / canvas.clientHeight
        camera.updateProjectionMatrix()
      }

      // for (const mixer of mixers) {
      for (const { mixer } of mixerInfos) {
        mixer.update(deltaTime)
      }

      renderer.render(scene, camera)
      // if (composer) {
      //   composer.render();
      // }
      window.renderer = renderer

      this.frameid = requestAnimationFrame(render)
    }
    requestAnimationFrame(render)

    window.onkeyup = (e) => {
      if (e.key == "ArrowUp") {
        playNextAction(mixerInfos[0], 0, true)
      }
    }

    window.onkeydown = (e) => {
      // if (e.key == "ArrowUp") {
      //   playNextAction(mixerInfos[0], 3, true)
      // }
      if (e.key == "ArrowLeft") {
        root.rotation.y += 12 * 1 * deltaTime
      }
      if (e.key == "ArrowRight") {
        root.rotation.y += 12 * -1 * deltaTime
      }

      // const mixerInfo = mixerInfos[0]
      // if (!mixerInfo) {
      //   return
      // }
      // playNextAction(mixerInfo)
    }
  },
  data() {
    return {
      camera: null,
      omAudio: null,
      increaseYValue: 0.09,
      decreaseYValue: 0.1,
      smallMoonRandomColorInterval: null,
      isLocalhost: window.window.location.href.indexOf("localhost") > -1,
      uniforms: {
        cValue: 1.3,
        pValue: 2.1,
      },
      lang: null,
      domEvents: null,
      frameid: null,
      bloomPass: null,
      params: {
        exposure: 1,
        bloomStrength: 1.5,
        bloomThreshold: 0,
        bloomRadius: 0,
        modelcolor: "#ff0000",
        candraXAxis: null,
        candraYAxis: null,
        candraZAxis: null,
      },
      candraSceneScale: {},
      candraScale: {},
    }
  },
  methods: {
    initOmAudio() {
      this.omAudio = new Audio("../audio/omkara.mp3")
    },
    createOmkaraHandTexture() {
      setTimeout(() => {
        const omkaraTexture = THREE.ImageUtils.loadTexture(
          "../img/three/OM.jpeg"
        )
        omkaraTexture.rotation = 3.1
        window.omkaraTexture = omkaraTexture
        const omkaraMaterial = new THREE.MeshBasicMaterial({
          map: omkaraTexture,
        })

        omkaraMaterial.map.wrapS = THREE.RepeatWrapping
        omkaraMaterial.map.wrapT = THREE.RepeatWrapping
        window.omkaraMaterial = omkaraMaterial

        window.drumShiva.rightOmkaraHandMesh.material = omkaraMaterial
        window.drumShiva.rightOmkaraHandMesh.needsUpdate = true
        window.drumShiva.colors = {
          skinkColor:
            window.drumShiva.children[0].children[0].children[1].children[2]
              .material.color,
          drumColor:
            window.drumShiva.children[0].children[0].children[1].children[1]
              .material.color,
          garlandColor:
            window.drumShiva.children[0].children[0].children[1].children[0]
              .material.color,
        }

        omkaraTexture.repeat.set(-180, 75)
        this.increaseY()
        this.changeColorsAnimation()
        this.initMouseEventForRightHandMesh()
      }, 100)
    },
    initMouseEventForRightHandMesh() {
      this.domEvents.addEventListener(
        window.drumShiva.rightOmkaraHandMesh,
        "mouseover",
        () => (document.body.style.cursor = "pointer"),
        false
      )

      this.domEvents.addEventListener(
        window.drumShiva.rightOmkaraHandMesh,
        "mouseout",
        () => (document.body.style.cursor = ""),
        false
      )

      this.domEvents.addEventListener(
        window.drumShiva.rightOmkaraHandMesh,
        "click",
        () => {
          this.omAudio.readyState > 1 ? this.omAudio.play() : null
          const originalCameraPosition = this.camera.position,
            targetPosition = {
              x: -1.45,
              y: 1,
              z: 3.7218613067446085,
            }
          
          let { x, y, z } = { ...originalCameraPosition }
           x  = Number.parseFloat(x.toFixed(3))
           y  = Number.parseFloat(y.toFixed(3))
           z  = Number.parseFloat(z.toFixed(3))

          let xEqual = Math.ceil(x - targetPosition.x) == 0,
           yEqual = Math.ceil(y - targetPosition.y) == 0,
           zEqual = Math.ceil(z - targetPosition.z) == 0

           if (
              !xEqual &&
              !yEqual &&
              !zEqual
            ) {
              
              const zoomInterval = setInterval(() => {
                
                 xEqual = Math.ceil(x - targetPosition.x) == 0
                if (!xEqual) {
                  if (x < targetPosition.x) {
                    x += 0.5
                  } else if (x > targetPosition.x) {
                    x -= 0.5
                  }
                }
    
                 yEqual = Math.ceil(y - targetPosition.y) == 0
                if (!yEqual) {
                  if (y < targetPosition.y) {
                    y += 0.5
                  } else if (y > targetPosition.y) {
                    y -= 0.5
                  }
                }
    
                 zEqual = Math.ceil(z - targetPosition.z) == 0
                if (!zEqual) {
                  if (z < targetPosition.z) {
                    z += 0.5
                  } else if (z > targetPosition.z) {
                    z -= 0.5
                  }
                }
    
                this.camera.position.set(x, y, z)
    
                if (
                  xEqual &&
                  yEqual &&
                  zEqual
                ) {
                  clearInterval(zoomInterval)
                }
              }, 15)

            }

        },
        false
      )
    },
    changeColorsAnimation() {
      const originalColors = {
          skinkColor: window.drumShiva.colors.skinkColor.color,
          drumColor: window.drumShiva.colors.drumColor.color,
          garlandColor: window.drumShiva.colors.garlandColor.color,
        },
        colors = [
          "yellow",
          "red",
          "blue",
          "green",
          "gray",
          "gold",
          "purple",
          "brown",
          "orange",
        ]

      setInterval(() => {
        const c = colors[Math.floor(Math.random() * (9 - 0) + 0)]
        window.drumShiva.colors.skinkColor.setColorName(c)
        if (c != "gray") {
          setTimeout(() => {
            window.drumShiva.colors.skinkColor.setColorName("gray")
          }, 1000)
        }
      }, 10000)
    },
    increaseY() {
      const increaseInterval = setInterval(() => {
        if (window.omkaraTexture.repeat.y <= 105) {
          omkaraTexture.repeat.y += this.increaseYValue //0.09
        } else {
          clearInterval(increaseInterval)
          this.decreaseY()
          // this.increaseYValue += .08
          // if (this.increaseYValue > .7) {
          //   this.increaseYValue = .09
          // }
        }
      }, 35)
    },
    decreaseY() {
      const decreaseInterval = setInterval(() => {
        if (window.omkaraTexture.repeat.y >= 75) {
          omkaraTexture.repeat.y -= this.decreaseYValue // 0.12
        } else {
          clearInterval(decreaseInterval)
          this.increaseY()
          // this.decreaseYValue += .08
          // if (this.decreaseYValue > .7) {
          //   this.decreaseYValue = .1
          // }
        }
      }, 35)
    },
    goLeft() {
      const leftInterval = setInterval(() => {
        let { x, y } = { ...window.backgroundMoon.bigGlow.position }

        if (x >= -21) {
          // subtract
          x -= 0.1
          y += 0.1
        } else {
          clearInterval(leftInterval)
          this.goRight()
        }

        window.backgroundMoon.bigGlow.position.x = x
        window.backgroundMoon.moon.position.x = x
      }, 100)
    },
    goRight() {
      const rightInterval = setInterval(() => {
        let x = window.backgroundMoon.bigGlow.position.x

        if (x <= 21) {
          // add
          x += 0.1
        } else {
          clearInterval(rightInterval)
          this.goLeft()
        }

        window.backgroundMoon.bigGlow.position.x = x
        window.backgroundMoon.moon.position.x = x
      }, 100)
    },
    goUp() {
      const upInterval = setInterval(() => {
        let y = window.backgroundMoon.bigGlow.position.y
        if (y <= 21) {
          y += 0.05
        } else {
          clearInterval(upInterval)
          this.goDown()
        }
        window.backgroundMoon.bigGlow.position.y = y
        window.backgroundMoon.moon.position.y = y
      }, 50)
    },
    goDown() {
      const downInterval = setInterval(() => {
        let y = window.backgroundMoon.bigGlow.position.y
        if (y >= -4) {
          y -= 0.05
        } else {
          clearInterval(downInterval)
          this.goUp()
        }
        window.backgroundMoon.bigGlow.position.y = y
        window.backgroundMoon.moon.position.y = y
      }, 50)
    },
    initBigMoonEffects() {
      setInterval(() => {
        const colorName = Object.keys(THREE.Color.NAMES)[
          Math.ceil(Math.random() * 147)
        ]
        window.backgroundMoon.bigGlow.material.uniforms.glowColor.value.setColorName(
          colorName
        )
      }, 500)
      setInterval(() => {
        window.backgroundMoon.moon.rotation.x += 0.05
        window.backgroundMoon.moon.rotation.y += 0.1
      }, 50)

      let x = window.backgroundMoon.bigGlow.position.x,
        y = window.backgroundMoon.bigGlow.position.y,
        z = window.backgroundMoon.bigGlow.position.z

      if (x >= -15) {
        this.goLeft()
      } else {
        this.goRight()
      }

      if (y >= 5) {
        this.goUp()
      } else {
        this.goDown()
      }

      //

      this.zAxisAnimation(z)
    },
    zAxisAnimation(z) {
      if (z <= 60) {
        this.increaseZ()
      } else {
        this.decreaseZ()
      }
    },
    increaseZ() {
      const increaseZInterval = setInterval(() => {
        let z = window.backgroundMoon.bigGlow.position.z
        if (z <= 55) {
          z += 0.1
        } else {
          clearInterval(increaseZInterval)
          this.decreaseZ()
        }
        window.backgroundMoon.bigGlow.position.z = z
        window.backgroundMoon.moon.position.z = z
      }, 100)
    },
    decreaseZ() {
      const decreaseZInterval = setInterval(() => {
        let z = window.backgroundMoon.bigGlow.position.z
        if (z >= -55) {
          z -= 0.1
        } else {
          clearInterval(decreaseZInterval)
          this.decreaseZ()
        }
        window.backgroundMoon.bigGlow.position.z = z
        window.backgroundMoon.moon.position.z = z
      }, 100)
    },
    contractEffect() {
      let { x, y, z } = { ...window.glow.scale }
      let contractInterval = setInterval(() => {
        if (x > 1.5) {
          x -= 0.1
          y -= 0.1
          z -= 0.1
          window.glow.scale.set(x, y, z)
        } else if (x == 1.5) {
          clearInterval(contractInterval)
          // this.contractEffect()
        }
      }, 5)
    },
    expandEffect() {
      let { x, y, z } = { ...window.glow.scale }
      let expandInterval = setInterval(() => {
        if (x <= 3) {
          x += 0.1
          y += 0.1
          z += 0.1
          window.glow.scale.set(x, y, z)
        } else if (x > 3) {
          clearInterval(expandInterval)
          // this.contractEffect()
        }
      }, 5)
    },
    initExpand() {
      this.smallMoonRandomColorInterval = setInterval(() => {
        const colorName = Object.keys(THREE.Color.NAMES)[
          Math.ceil(Math.random() * 147)
        ]
        window.glow.material.uniforms.glowColor.value.setColorName(colorName)
      }, 500)
      this.expandEffect()
    },
    initContraction() {
      this.contractEffect()
      setTimeout(() => {
        this.smallMoonRandomColorInterval
          ? clearInterval(this.smallMoonRandomColorInterval)
          : null
      }, 5000)
    },
    initUserEvents() {
      this.domEvents.addEventListener(
        window.glow,
        "mouseover",
        this.initExpand,
        false
      )

      this.domEvents.addEventListener(
        window.glow,
        "mouseout",
        this.initContraction,
        false
      )
    },
    createGlowEffect() {
      const customMaterial = new THREE.ShaderMaterial({
        uniforms: {
          c: { type: "f", value: 1.3 },
          p: { type: "f", value: 2.1 },
          glowColor: { type: "c", value: new THREE.Color(0xffff00) },
          viewVector: { type: "v3", value: camera.position },
        },
        vertexShader: document.getElementById("vertexShader").textContent,
        fragmentShader: document.getElementById("fragmentShader").textContent,
        side: THREE.FrontSide,
        blending: THREE.AdditiveBlending,
        transparent: true,
      })
      return customMaterial
    },
    reduceScale(glb) {
      const xSceneScale = glb.scene.scale.x,
        ySceneScale = glb.scene.scale.y,
        zSceneScale = glb.scene.scale.z,
        xCandraScale = glb.scene.children[0].scale.x,
        yCandraScale = glb.scene.children[0].scale.y,
        zCandraScale = glb.scene.children[0].scale.z

      glb.scene.scale.set(
        xSceneScale * 0.4,
        ySceneScale * 0.2,
        zSceneScale * 0.5
      )

      this.candraSceneScale = {
        xSceneScale: glb.scene.scale.x,
        ySceneScale: glb.scene.scale.y,
        zSceneScale: glb.scene.scale.z,
      }

      this.candraScale = {
        xCandraScale: xCandraScale,
        yCandraScale: yCandraScale,
        zCandraScale: zCandraScale,
      }
    },

    addMaterialControls() {
      let parameters = {
        c: this.uniforms.cValue,
        p: this.uniforms.pValue,
        bs: false,
        fs: true,
        nb: false,
        ab: true,
        mv: true,
        color: "#ffff00",
      }

      const top = this.gui.addFolder("Glow Shader Attributes")

      const cGUI = top
        .add(parameters, "c")
        .min(0.0)
        .max(1.0)
        .step(0.01)
        .name("c")
        .listen()
      cGUI.onChange(function (value) {
        window.backgroundMoon.bigGlow.material.uniforms["c"].value =
          parameters.c
        window.glow.material.uniforms["c"].value = parameters.c
      })

      // var pGUI = top
      //   .add(parameters, "p")
      //   .min(0.0)
      //   .max(6.0)
      //   .step(0.01)
      //   .name("p")
      //   .listen()
      // pGUI.onChange(function (value) {
      //   moonGlow.material.uniforms["p"].value = parameters.p
      //   crateGlow.material.uniforms["p"].value = parameters.p
      // })

      // var glowColor = top
      //   .addColor(parameters, "color")
      //   .name("Glow Color")
      //   .listen()
      // glowColor.onChange(function (value) {
      //   moonGlow.material.uniforms.glowColor.value.setHex(
      //     value.replace("#", "0x")
      //   )
      //   crateGlow.material.uniforms.glowColor.value.setHex(
      //     value.replace("#", "0x")
      //   )
      // })
    },

    addGuiControls() {
      // this.gui.add(this.params, "exposure", 0.1, 2).onChange( value => {
      //   window.renderer.toneMappingExposure = Math.pow(value, 4.0)
      // })

      // this.gui
      //   .add(this.params, "bloomThreshold", 0.0, 1.0)
      //   .onChange( value => {
      //     this.bloomPass.threshold = Number(value)
      //   })

      // this.gui
      //   .add(this.params, "bloomStrength", 0.0, 3.0)
      //   .onChange( value => {
      //     this.bloomPass.strength = Number(value)
      //   })

      // this.gui
      //   .add(this.params, "bloomRadius", 0.0, 1.0)
      //   .step(0.01)
      //   .onChange( value => {
      //     this.bloomPass.radius = Number(value)
      //   })

      // const folder = this.gui.addFolder("Model Colour")
      // folder
      //   .addColor(this.params, "modelcolor")
      //   .name("Model Color")
      //   .onChange(() => {
      //     // window.candra.material.color.set(this.params.modelcolor);
      //     // window.candra.material.emissive.set(this.params.modelcolor);
      //     candraScene.children[0].children[0].material.emissive.set(
      //       this.params.modelcolor
      //     )
      //   })
      // folder.open()
    },

    initCandraControls() {
      this.gui
        .add(window.candra.rotation, "x", -10, 10, { propLabel: "rotation X" })
        .step(0.01)
        .onChange((value) => {
          window.candra.rotation.x = Number(value)
        })

      this.gui
        .add(window.candra.rotation, "y", -20, 20, { propLabel: "rotation X" })
        .step(0.01)
        .onChange((value) => {
          window.candra.rotation.y = Number(value)
        })

      this.gui
        .add(window.candra.rotation, "z", -20, 20, { propLabel: "rotation X" })
        .step(0.01)
        .onChange((value) => {
          window.candra.rotation.z = Number(value)
        })

      this.gui
        .add(window.candra.position, "x", -100, 100, {
          propLabel: "position X",
        })
        .step(0.01)
        .onChange((value) => {
          window.candra.position.x = Number(value)
        })

      this.gui
        .add(window.glb.scene.position, "y", -100, 400, {
          propLabel: "position Y",
        })
        .step(0.01)
        .onChange((value) => {
          window.candra.position.y = Number(value)
          window.glb.scene.position.y = Number(value)
        })

      // this.gui
      //   .add(window.candra.position, "z", -100, 100, {
      //     propLabel: "position Z",
      //   })
      //   .step(0.01)
      //   .onChange((value) => {
      //     window.candra.position.z = Number(value)
      //   })

      // this.gui
      // .add(window.glb.scene.scale, "x", -10, 10, {propLabel: 'scale X'})
      // .step(0.01)
      // .onChange( value => {
      //   window.glb.scene.scale.x *= Number(value)
      // })

      // this.gui
      // .add(window.glb.scene.scale, "y", -10, 10, {propLabel: 'scale y'})
      // .step(0.01)
      // .onChange( value => {
      //   window.glb.scene.scale.y *= Number(value)
      // })

      // this.gui
      // .add(window.glb.scene.scale, "z", -10, 10, {propLabel: 'scale z'})
      // .step(0.01)
      // .onChange( value => {
      //   window.glb.scene.scale.z *= Number(value)
      // })
    },

    setLang(l) {
      this.lang = l
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    },
  },
}
</script>

<style scoped>
html,
body {
  margin: 0;
  height: 100%;
}
#c,
#three-d-character {
  width: 100%;
  height: 100%;
  display: block;
}
#loading {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: xx-large;
  font-family: sans-serif;
}
#loading > div > div {
  padding: 2px;
}
.progress {
  width: 50vw;
  border: 1px solid black;
}
#progressbar {
  width: 0;
  transition: width ease-out 0.5s;
  height: 1em;
  background-color: #888;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.5) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0.5) 75%,
    transparent 75%,
    transparent
  );
  background-size: 50px 50px;
  animation: progressanim 2s linear infinite;
}

@keyframes progressanim {
  0% {
    background-position: 50px 50px;
  }
  100% {
    background-position: 0 0;
  }
}
</style>

<style>
#app {
  padding: 0;
}

.cr.number.has-slider {
  margin: 0;
}

.dg.ac {
  top: 14%;
}

#three-d-character,
#c {
  min-height: 700px;
}

@media screen and (max-width: 700px) and (max-height: 500px) {
  #three-d-character,
  #c {
    min-height: 450px;
  }
}
</style>